(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kulta-quick-buy-calculator-fix"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const drawerSelector = 'quick-buy-drawer';
    const calculatorBlockSelector = '[id*="diy_quantity_calculator_app_block"]';

    const readCoverage = (block) => {
      const configScript = Array.from(block.querySelectorAll('script'))
        .find((script) => script.textContent.includes('en_qc_coverage'));
      const coverage = {};

      if (!configScript) return coverage;

      for (const match of configScript.textContent.matchAll(/["'](\d+)["']\s*:\s*["']([\d.]+)["']/g)) {
        coverage[match[1]] = Number(match[2]);
      }

      return coverage;
    };

    const readSelectedVariantId = (drawer) => {
      const variantJson = drawer.querySelector('variant-picker script[data-variant]')?.textContent;

      if (variantJson) {
        try {
          return String(JSON.parse(variantJson).id || '');
        } catch {}
      }

      return String(drawer.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '');
    };

    const getQuantityInput = (drawer) => {
      const form = drawer.querySelector('form[action*="/cart/add"]');
      if (!form) return null;

      let quantityInput = form.querySelector('input[name="quantity"]');

      if (!quantityInput) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';
        form.appendChild(quantityInput);
      }

      return quantityInput;
    };

    const initialiseCalculator = (drawer, requestedVariantId = '') => {
      if (!(drawer instanceof HTMLElement)) return;

      const block = drawer.querySelector(calculatorBlockSelector);
      const calculator = block?.querySelector('q-calculator');
      const areaInput = calculator?.querySelector('input');

      if (!block || !calculator || !areaInput) return;

      const coverage = readCoverage(block);
      const variantId = requestedVariantId || readSelectedVariantId(drawer);
      const firstCoverage = Object.values(coverage)[0];
      const coveragePerUnit = Number(coverage[variantId] || firstCoverage);

      if (!Number.isFinite(coveragePerUnit) || coveragePerUnit <= 0) return;

      areaInput.id = areaInput.id || 's-feet';
      areaInput.dataset.vpu = String(coveragePerUnit);

      if (drawer.dataset.kultaCoverageValue) {
        areaInput.value = drawer.dataset.kultaCoverageValue;
      } else if (!Number.isFinite(Number(areaInput.value)) || Number(areaInput.value) <= 0) {
        areaInput.value = String(coveragePerUnit);
      }

      const syncQuantity = () => {
        const requestedArea = Number(areaInput.value);
        const currentCoveragePerUnit = Number(areaInput.dataset.vpu);
        if (!Number.isFinite(requestedArea) || requestedArea < 0) return;
        if (!Number.isFinite(currentCoveragePerUnit) || currentCoveragePerUnit <= 0) return;

        drawer.dataset.kultaCoverageValue = areaInput.value;

        const quantityInput = getQuantityInput(drawer);
        if (!quantityInput) return;

        const nextQuantity = requestedArea === 0 ? 1 : Math.max(1, Math.ceil(requestedArea / currentCoveragePerUnit));
        if (quantityInput.value === String(nextQuantity)) return;

        quantityInput.value = String(nextQuantity);
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      if (areaInput.dataset.kultaQuickBuyBound !== 'true') {
        areaInput.dataset.kultaQuickBuyBound = 'true';
        areaInput.addEventListener('input', syncQuantity);
        areaInput.addEventListener('change', syncQuantity);
      }

      syncQuantity();
    };

    document.addEventListener('variant:change', (event) => {
      const drawer = event.target.closest(drawerSelector);
      if (!drawer) return;

      requestAnimationFrame(() => {
        initialiseCalculator(drawer, String(event.detail?.variant?.id || ''));
      });
    });

    const observer = new MutationObserver((mutations) => {
      const drawers = new Set();

      for (const mutation of mutations) {
        const drawer = mutation.target instanceof Element
          ? mutation.target.closest(drawerSelector)
          : null;
        if (drawer) drawers.add(drawer);

        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(drawerSelector)) drawers.add(node);
          node.querySelectorAll?.(drawerSelector).forEach((item) => drawers.add(item));
          const parentDrawer = node.closest?.(drawerSelector);
          if (parentDrawer) drawers.add(parentDrawer);
        }
      }

      drawers.forEach((drawer) => initialiseCalculator(drawer));
    });

    const start = () => {
      observer.observe(document.body, { childList: true, subtree: true });
      document.querySelectorAll(drawerSelector + '[open]').forEach((drawer) => initialiseCalculator(drawer));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
